import React, { useEffect, useState } from "react";
import Route from "./Route";
import { useNavigate } from "react-router-dom";
import { RiDashboard3Fill } from "react-icons/ri";
import { ImMenu } from "react-icons/im";
import SubRoute from "./SubRoute";

export default function NavBar() {
  const navigate = useNavigate();

  return (
    <div className="bg-[#303641] w-full">
      <div className="font-bold flex items-center  justify-between text-3xl p-4 text-white">
        <div className="">BASE APP</div>
        <ImMenu className="text-2xl" />
      </div>

      <div className="mt-10">
        <Route
          name="Home"
          onClick={() => navigate("home")}
          icon={<RiDashboard3Fill />}
          urlPath="home"
        />

        <Route
          name="Profile"
          onClick={() => navigate("profile")}
          urlPath="profile"
        />
      </div>
    </div>
  );
}
